import { AxiosResponse } from "axios";
import apiClient from "../../../../shared/infrastructure/api/client";
import { MarketplaceFilters, TherapyTool } from "../../domain/types";

function toParams(filters: MarketplaceFilters): Record<string, string> {
    const params: Record<string, string> = {};
    if (filters.therapyType) params.therapy_type = filters.therapyType;
    if (filters.priceModel) params.price_model = filters.priceModel;
    if (filters.category) params.category = filters.category;
    if (filters.search) params.search = filters.search;
    return params;
}

export const MarketplaceAPI = {
    list: (filters: MarketplaceFilters = {}): Promise<AxiosResponse<TherapyTool[]>> =>
        apiClient.get("/therapy-tools", { params: toParams(filters) }),
    listAdopted: (): Promise<AxiosResponse<TherapyTool[]>> =>
        apiClient.get("/therapy-tools/adopted"),
    detail: (slug: string): Promise<AxiosResponse<TherapyTool>> =>
        apiClient.get(`/therapy-tools/${slug}`),
    adopt: (toolId: string): Promise<AxiosResponse<void>> =>
        apiClient.post(`/therapy-tools/${toolId}/adopt`),
    remove: (toolId: string): Promise<AxiosResponse<void>> =>
        apiClient.delete(`/therapy-tools/${toolId}/adopt`),
};
